import "./PushToggle.scss";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import FlowCheckbox from "../FlowCheckbox/FlowCheckbox";
import {
  isPushSupported,
  needsHomeScreenInstall,
  getPushSubscription,
  enablePush,
  disablePush,
} from "../../utils/pushNotifications";

// Turns web push on/off for this device
function PushToggle() {
  const { t } = useTranslation();
  const [isEnabled, setIsEnabled] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    getPushSubscription()
      .then((subscription) => setIsEnabled(Boolean(subscription)))
      .catch(() => setIsEnabled(false));
  }, []);

  const handleChange = async (enable) => {
    setIsBusy(true);
    setError(null);
    try {
      if (enable) {
        await enablePush();
      } else {
        await disablePush();
      }
      setIsEnabled(enable);
    } catch (err) {
      console.error("Error changing push notifications:", err);
      setError(err.message);
      setIsEnabled(!enable);
    } finally {
      setIsBusy(false);
    }
  };

  if (needsHomeScreenInstall()) {
    return (
      <div className="push-toggle push-toggle--hint">
        {t("notifications.push.homeScreenHint")}
      </div>
    );
  }

  if (!isPushSupported()) {
    return (
      <div className="push-toggle push-toggle--hint">
        {t("notifications.push.notSupported")}
      </div>
    );
  }

  return (
    <div className="push-toggle">
      <FlowCheckbox
        checked={isEnabled}
        disabled={isBusy}
        onChange={handleChange}
        label={t("notifications.push.label")}
      />
      {error && <div className="push-toggle__error">{error}</div>}
    </div>
  );
}

export default PushToggle;
